import axios from 'axios';

/**
 * Check if the employer has permission to view contact information
 * @param {Object} params - Parameters for the request
 * @param {Number} params.employerId - ID of the employer
 * @param {Number} params.jobseekerId - ID of the jobseeker
 * @param {Object} params.features - Subscription features
 * @param {String} params.token - Authentication token
 * @returns {Promise<Object>} - Result of the permission check
 */
export const checkContactRevealPermission = async ({ employerId, jobseekerId, features, token }) => {
    try {
        if (!employerId || !jobseekerId || !features || !token) {
            return { 
                canReveal: false, 
                reason: 'MISSING_DATA',
                message: 'Missing required data'
            };
        }

        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}user/contacts/check-reveal`,
            { employerId, jobseekerId, features, token },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error checking contact reveal permission:', error);
        return { 
            canReveal: false, 
            reason: 'ERROR',
            message: 'Failed to check permission'
        };
    }
};

/**
 * Record that an employer has revealed a jobseeker's contact information
 * @param {Object} params - Parameters for the request
 * @param {Number} params.employerId - ID of the employer
 * @param {Number} params.jobseekerId - ID of the jobseeker
 * @param {String} params.token - Authentication token
 * @returns {Promise<Object>} - Result of the record operation
 */
export const recordContactReveal = async ({ employerId, jobseekerId, token }) => {
    try {
        if (!employerId || !jobseekerId || !token) {
            throw new Error('Missing required data');
        }

        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}user/contacts/record-reveal`,
            { employerId, jobseekerId, token },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
        return response.data;
    } catch (error) {
        console.error('Error recording contact reveal:', error);
        throw error;
    }
}; 